import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class FilesService {
  constructor(private http: HttpClient) {}

  getById(sample_id: number) {
    return this.http.get<any>(`${environment.apiUrl}/files/get_Fields/${sample_id}`)
  }

  downloadFile(sampleId) {
    return this.http.get(`${environment.apiUrl}/files/download/request-attachment/${sampleId}`, {
      responseType: 'blob' as 'json'
    })
  }

  downloadFiles(sampleId) {
    return this.http.get(`${environment.apiUrl}/files/export_pdf/${sampleId}`, {
      responseType: 'blob' as 'json'
    })
  }

  upload(formData, sample_id, data) {
    return this.http.post<any>(
      `${environment.apiUrl}/files/upload-attachment/${sample_id}/${data.cuantitative}/${data.cualitative}/${data.cuantitative_notes}/${data.cualitative_notes}`,
      formData
    )
  }

  delete(file_id) {
    return this.http.post<any>(`${environment.apiUrl}/files/delete_Files/${file_id}`, file_id)
  }
}
